// 📁 src/components/Payment/CreditCardForm.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fakeCardPaymentAPI } from '../../utils/paymentMocks';
import { recordPayment } from '../../utils/recordPayment';
import '../../styles/payment.css';
import Toast from '../common/Toast';
import '../common/Toast.css';

const CreditCardForm = ({
  selectedModules,
  onSuccess,
  onFailure,
  companyName,
  tenantId,
  billingCycle,
  currency,
  annualDiscountRate = 0 // ✅ Canonical discount prop
}) => {
  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvv, setCvv] = useState('');
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [errorToast, setErrorToast] = useState('');
  const [emailStatusMessage, setEmailStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [paid, setPaid] = useState(false); // ✅ track paid state
  const navigate = useNavigate();

  const grandTotal = Math.round(selectedModules.reduce((sum, mod) => sum + mod.price, 0));

  const handlePayment = async () => {
    setLoading(true);
    try {
      const response = await fakeCardPaymentAPI({
        cardNumber,
        expiry,
        cvv,
        amount: grandTotal,
        currency
      });
      if (response.status === 'success') {
        const email =
          sessionStorage.getItem('isLoggedIn') === 'true' ? localStorage.getItem('email') : null;

        const result = await recordPayment({
          email,
          amount: grandTotal,
          method: 'Credit Card',
          selectedModules,
          companyName,
          tenantId,
          billingCycle,
          currency,
          annualDiscountRate // ✅ Canonical field passed
        });

        const invoiceNo = result?.invoiceNo || 'N/A';
        sessionStorage.setItem('invoicePreviewData', JSON.stringify({ email, invoiceNo }));

        console.log('📤 Triggering invoice email with:', { email });

        try {
          const emailResponse = await fetch('http://localhost:3001/api/email/send-invoice-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
          });

          const result = await emailResponse.json();
          if (emailResponse.ok && result.success) {
            setEmailStatusMessage('📧 A payment confirmation email has been sent to your email.');
          } else {
            setEmailStatusMessage('⚠️ Payment succeeded, but email confirmation failed.');
          }
        } catch (err) {
          setEmailStatusMessage('⚠️ Payment succeeded, but email confirmation failed.');
        }

        onSuccess?.();
        setShowSuccessToast(true);
        setPaid(true); // ✅ mark as paid
        setTimeout(() => setShowSuccessToast(false), 4000);

        setTimeout(() => {
          window.open('/invoice-preview', '_blank');
          navigate('/my-account/software');
        }, 2000);
      } else {
        onFailure?.(response.message);
        setErrorToast(response.message);
        setTimeout(() => setErrorToast(''), 4000);
      }
    } catch (error) {
      onFailure?.(error.message);
      setErrorToast(error.message);
      setTimeout(() => setErrorToast(''), 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="credit-card-form">
      <h3>Pay with Credit Card</h3>
      <input
        type="text"
        placeholder="Card Number"
        value={cardNumber}
        onChange={(e) => setCardNumber(e.target.value)}
      />
      <input
        type="text"
        placeholder="Expiry Date (MM/YY)"
        value={expiry}
        onChange={(e) => setExpiry(e.target.value)}
      />
      <input type="text" placeholder="CVV" value={cvv} onChange={(e) => setCvv(e.target.value)} />
      <button onClick={handlePayment} disabled={loading || paid}>
        {loading ? (
          <span>
            <span className="spinner" /> Processing payment…
          </span>
        ) : paid ? (
          'Paid'
        ) : (
          `Pay ${currency} ${grandTotal.toFixed(2)}`
        )}
      </button>

      {showSuccessToast && (
        <>
          <Toast
            message={`Payment of ${currency} ${grandTotal.toFixed(2)} successful!`}
            type="success"
            onClose={() => setShowSuccessToast(false)}
          />
          {emailStatusMessage && (
            <p style={{ marginTop: '8px', color: 'green', fontWeight: 'bold' }}>
              {emailStatusMessage}
            </p>
          )}
        </>
      )}
      {errorToast && <Toast message={errorToast} type="error" onClose={() => setErrorToast('')} />}
    </div>
  );
};

export default CreditCardForm;
